import { render } from "./TheoryMediumDevice.vue?vue&type=template&id=5bca3108&scoped=true"
import script from "./TheoryMediumDevice.vue?vue&type=script&lang=js"
export * from "./TheoryMediumDevice.vue?vue&type=script&lang=js"

import "./TheoryMediumDevice.vue?vue&type=style&index=0&id=5bca3108&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bca3108"]])

export default __exports__